<template>
  <div id="capa">
    <center> 
       <br v-if="isMobile"><br v-if="isMobile">
      <p :class="isMobile ? (espera == 1 ? 'line-22' : 'line-2 anim-typewriter') : (espera == 1 ? 'line-11' : 'line-1 anim-typewriter')" >Por los</p> 
       <template v-if="espera == 1">
          <br v-if="isMobile">
          <b-row class="justify-content-center" :style="isMobile ? 'margin-top:-68px;' : (anima4 == 1 ? 'margin-top:108px;' : 'margin-top:-88px;')">
            <b-col cols="12" md="5" lg="12" xl="12">  
                  <div data-aos="flip-left" data-aos-delay="650"     data-aos-duration="1000" >  
                    <img src="img/rifa.png" :class="anima4 == 0 ? 'rounded' : 'rounded zoom-in-out-box '" alt="Image" :style="isMobile ? 'width:90%;' : 'width:38%;'">
                  </div>
                  <div data-aos="zoom-in" data-aos-delay="2850"     data-aos-duration="500"    > 
                    <img src="img/login1.png" :class="anima == 0 ? 'rounded' : 'rounded'" alt="Image" :style="isMobile ? 'width:90%; margin-top:-60px;' : 'width:38%; margin-top:-90px;'">
                  </div>
                  <div data-aos="zoom-in" data-aos-delay="2900"     data-aos-duration="700"    > 
                    <img src="img/login2.png" :class="anima2 == 0 ? 'rounded' : 'rounded zoom-in-out-box '"  alt="Image" :style="isMobile ? 'width:90%; margin-top:-55px;' : 'width:38%; margin-top:-80px;'">
                  </div>  
            </b-col>
          </b-row>
          <br><br>  <br v-if="!isMobile"><br v-if="!isMobile">
          <div data-aos="zoom-in" data-aos-delay="2950"     data-aos-duration="900" >
            <p v-if="perfil == 0" :style="isMobile ? 'font-size:20px; color:#ffffff; margin-top:-21px;' 
            : 'font-size:22px; color:#ffffff; margin-top:-90px;'"  >
              ¡Éntrale!
            </p>
          </div>  
          <b-row class="justify-content-center" :style="isMobile ? 'margin-top: -30px;' : 'margin-top: -28px;'">
            <b-col cols="11" md="6"   v-if="perfil == 0">
              <br v-if="isMobile">
              <div data-aos="zoom-in"  data-aos-delay="2850"     data-aos-duration="700"    > 
                  <b-row class="justify-content-center mt-5" > 
                      <b-col cols="10" md="10" lg="4" xl="4">
                        <div class="row">
                          <div class="col-2">
                            <img src="img/estrella.webp" class="rounded zoom-in-out-box"  alt="Image" :style="isMobile ? 'width:99%; margin-left: 25px; margin-top: 8px;' : 'width:94%; margin-left: 25px; margin-top: 15px;'"> 
                          </div>
                          <div class="col-10">
                            <img src="elementos/propios/propio2.png" :class="anima2 == 0 ? 'rounded' : 'rounded'" alt="Image" :style="isMobile ? 'width:90%; margin-left:-35px;' : 'width:105%; cursor:pointer; margin-left:-25px;'" @click="seleccionarCanal(3)"> 
                          </div>
                        </div> 
                      </b-col>
                      <b-col cols="10" md="10" lg="4" xl="4">
                        <br v-if="isMobile">
                        <div class="row">
                          <div class="col-2">
                            <img src="img/estrella.webp" class="rounded zoom-in-out-box"  alt="Image"  :style="isMobile ? 'width:99%; margin-left: 25px; margin-top: 8px;' : 'width:94%; margin-left: 25px; margin-top: 15px;'"> 
                          </div>
                          <div class="col-10">
                            <img src="elementos/especialista/espe2.png" :class="anima2 == 0 ? 'rounded' : 'rounded'" alt="Image" :style="isMobile ? 'width:90%; margin-left:-35px;' : 'width:105%; cursor:pointer; margin-left:-25px;'" @click="seleccionarCanal(4)" > 
                          </div>
                        </div> 
                      </b-col> 
                      <b-col cols="10" md="10" lg="4" xl="4"> 
                        <br v-if="isMobile">
                        <div class="row">
                            <div class="col-2">
                              <img src="img/estrella.webp" class="rounded zoom-in-out-box"  alt="Image"  :style="isMobile ? 'width:99%; margin-left: 25px; margin-top: 8px;' : 'width:94%; margin-left: 25px; margin-top: 15px;'"> 
                            </div>
                            <div class="col-10">
                              <img src="elementos/retails/retails2.png" :class="anima2 == 0 ? 'rounded' : 'rounded'" alt="Image" :style="isMobile ? 'width:90%; margin-left:-35px;' : 'width:105%; cursor:pointer; margin-left:-25px;'" @click="seleccionarCanal(1)" > 
                            </div>
                          </div> 
                      </b-col> 
                  </b-row>
              </div>
                  <br> 
            </b-col> 
          </b-row>    
          <div data-aos="zoom-in" data-aos-delay="2950"     data-aos-duration="900" >
            <img src="img/orgullomexa.png" :class="anima3 == 0 ? 'rounded' : 'rounded'" alt="Image" :style="isMobile ? 'width:85%;' : 'width:20%;'"> 
          </div>
            <div data-aos="fade-zoom-in" data-aos-delay="2950"     data-aos-duration="900" >
       <!-- <p class="text-white" v-if="perfil == 0">Si presentas problemas con tu ingreso; <u style="color:#0c273a; cursor: pointer;" @click="abrirContacto()">Contáctanos</u></p> -->
              <img src="img/estrella.webp" class="rounded zoom-in-out-box"  alt="Image" :style="isMobile ? 'width:12%;' : 'width:4%; margin-left:55px; margin-top:-450px;'"> 
              <img v-if="!isMobile" src="img/estrella.webp" class="rounded zoom-in-out-box"  alt="Image" :style="isMobile ? 'width:12%;' : 'width:4%; margin-left:1455px; margin-top:-650px;'">  
              <img v-if="!isMobile" src="img/estrella.webp" class="rounded zoom-in-out-box"  alt="Image" :style="isMobile ? 'width:12%;' : 'width:4%; margin-left:1225px; margin-top:-50px;'">    
            </div>
          </template>
     </center>
     <br> 
  </div>
</template>

<script>
  // import Multiselect from 'vue-multiselect'
// import $ from "jquery";
// import InitController from "@/utils/InitController";
import $ from "jquery";
export default {
  name: 'Inicio',
  //  components: { Multiselect },
  data(){
    return{
      isMobile: this.$mobile(),
      perfil:0,
      idpdv:"",
      email:"",
      mrt:"",
      errors:[],
      loader:false,
      agencia:0,
      cadena:0,
      arrayAgencia:[],
      arrayCadena:[],
      arrayPdv:[],
      canal:0,
      correo:"",
      descripcion:"",
      options: [
          { value: 0, text: 'Seleccione el canal al que pertenece' },
          { value: 1, text: 'Retail' },
          { value: 2, text: 'TLMKT' },
          { value: 3, text: 'Propio' },
        ],
      enviar:false,
      val:0,
      vertical:0,
      anima:0,
      anima2:0,
      anima3:0,
      anima4:0,
      espera:0,
      estrella:0
    }
  },
  computed:{
      listadoCadena(){

        if (this.cadena == 0) {          
            return this.arrayPdv;
        }else{
               return   this.arrayPdv.filter(item => {
                    return  item.agencia?.toLowerCase().includes(this.agencia.toLowerCase()) &&
                            item.cadena?.toLowerCase().includes(this.cadena.toLowerCase()) 
                    ;
              });
        }
      }
  },
  methods:{
    seleccionarCanal(id){
      this.perfil = id;
      this.idpdv = "";
      this.mrt = "";
      this.agencia = 0;
      this.cadena = 0;
      this.errors = [];
      this.email = "";
      this.val = 0; 
      this.$bus.$emit("cambia_login", this.perfil);
    },
    apibitacora(){   
     this.$api.post('auth/bitacora', {
          'correo' : this.email,
          'mrt' : this.mrt,
          'canal' : this.perfil,
          'perfil' : "",
          'region' : 'N/A',
          'url' : '/',
          'seccion' : 'Login',
          'accion' : 'Inicio sesión',
          'detalle' : 'Accedio a la convención',
        }).then(
          response => {
             console.log(response);
          })
    },
    login() { 
        this.errors = []; 
        let model = this.prepareModel()

        this.loader = true;
        let request = this.$api.post("auth/login", model);
        request.then(
            response => {   
                console.log(response)      
                this.loader = false;  
                
                    if (response.data.sesion == 0)
                    {
                        this.val = response.data.val;
                        this.mrt = "";
                        this.errors.push('sesion');       
                    }else{ 
                        this.$store.dispatch("setLogin", response.data); 
                        this.$bus.$emit("fondo_capa", "fondoCapa")
                        this.$router.push("/");  
                        // InitController.startMetrics(response.data);
                        this.apibitacora();
                        
                    }
                
            },
            error => {
                this.loader = false;
                console.log(error);
            }
        )
            
    },
    prepareModel() {
        let model = new FormData();
        model.append("idpdv", this.idpdv)
        model.append("email", this.email)
        model.append("mrt", this.mrt)
        model.append("cadena", this.cadena)
        model.append("agencia", this.agencia)
        model.append("perfil", this.perfil)
        return model;
    },
    selectores(){
      var url= 'auth/selectores';
        this.$api.get(url).then(
            ({data}) => {
                console.log(data);
                this.arrayAgencia = data.agencia;    
                this.arrayCadena = data.cadena;   
                this.arrayPdv = data.pdv;   
            }
        );
    },
    abrirContacto(){
      this.$bvModal.show('contactoAyuda');
    },
    cerrarModal(){
      this.correo = "";
      this.descripcion = "";
      this.canal = 0;
      this.errors = [];
      this.$bvModal.hide('contactoAyuda');
    },
    ayuda(e) {
       e.preventDefault();
        this.errors = [];
        let model = this.prepareModel2()
        
        if(this.canal == 0){
            this.errors.push('canal');     
        }else if (!this.correo){
            this.errors.push('email');       
        }else if(!this.descripcion){
            this.errors.push('descripcion');
        }else{
            this.loader = true;
            let request = this.$api.post("auth/ayuda", model);
            request.then(
                response => {   
                    console.log(response)      
                    this.loader = false;  
                    this.canal = 0;
                    this.correo = "";
                    this.descripcion = ""; 
                    this.enviar = true;          
                },
                error => {
                    this.loader = false;
                    console.log(error);
                }
            )
        }
    },
    prepareModel2() {
        let model = new FormData();
        model.append("canal", this.canal)
        model.append("correo", this.correo)
        model.append("descripcion", this.descripcion)
        return model;
    },
  },
  mounted(){
  var height  = $(window).height();
     console.log(height);
     
     if (height < 950 && !this.isMobile)
     {
        const elem2 = document.getElementById("capa");
         elem2.style.zoom='90%';  

        // this.$bus.$emit("ajusta_zoom")
     }  

     if (window.orientation == '90' && this.isMobile || window.orientation == '-90'  && this.isMobile )
     {
       this.vertical = 1;
     }
     
      window.AOS.init(); 

      setTimeout(() => {
        this.espera = 1;
          setTimeout(() => {
                this.anima4 = 1; 
                    setTimeout(() => {
                      this.anima4 = 0; 
                    }, 2200) 
              }, 700) 
            //   setTimeout(() => {
            //     this.anima = 1; 
            //         setTimeout(() => {
            //           this.anima = 0; 
            //         }, 300) 
            //   }, 500) 
              setTimeout(() => {
                this.anima2 = 1; 
                    setTimeout(() => {
                      this.anima2 = 0;  
                    }, 2500) 
              }, 2500) 
            // setTimeout(() => {
            //     this.anima3 = 1; 
            //         setTimeout(() => {
            //           this.anima3 = 0; 
            //         }, 500) 
            //   }, 900) 
         }, 2700)
  }
}
</script> 
<style>
.slide-fwd-center {
  transform: scale(3); 
}
 

.zoom-in-out-box { 
  animation: zoom-in-zoom-out 5s ease infinite; 
}

@keyframes zoom-in-zoom-out {
  0% {
      transform: scale(1.5); 
  }
  50% {
     transform: scale(1); 
  }
  100% {
      transform: scale(1.5); 
  }
}

 .zoom-in-out-box2 { 
  animation: zoom-in-zoom-out 1s ease infinite; 
}

@keyframes zoom-in-zoom-out2 {
  0% {
    scale: 100%
  }
  50% {
    scale: 150%;
  }
  100% {
    scale: 100%;
  }
}


      @font-face {
          font-family: 'Even';
          src: url("https://dev.convencioncomercial.com.mx/fonts/Ever-Sign.otf") format("opentype");
      }  


.line-1{
    position: relative;
    top: 145%;  
    width: 3em;
    margin: 0 auto;
    border-right: 2px solid rgba(255,255,255,.75);
    font-size: 280%;
    text-align: center;
    white-space: nowrap;
    overflow: hidden;
    transform: translateY(-50%);    
    color: #fff;
    font-family: Even, serif;
}

.line-11{
    position: relative;
    top: 145%;  
    width: 3em;
    margin: 0 auto;
    /* border-right: 2px solid rgba(255,255,255,.75); */
    font-size: 280%;
    text-align: center;
    white-space: nowrap;
    overflow: hidden;
    transform: translateY(-50%);    
    color: #fff;
    font-family: Even, serif;
}
.line-2{
    position: relative;
    top: 355%;  
    width: 3em;
    margin: 0 auto;
    border-right: 2px solid rgba(255,255,255,.75);
    font-size: 150%;
    text-align: center;
    white-space: nowrap;
    overflow: hidden;
    transform: translateY(-50%);    
    color: #fff;
    font-family: Even, serif;
}
.line-22{
    position: relative;
    top: 355%;  
    width: 3em;
    margin: 0 auto;
    /* border-right: 2px solid rgba(255,255,255,.75); */
    font-size: 150%;
    text-align: center;
    white-space: nowrap;
    overflow: hidden;
    transform: translateY(-50%);    
    color: #fff;
    font-family: Even, serif;
}
/* Animation */
.anim-typewriter{
  animation: typewriter 1s steps(44) 1s 1 normal both,
             blinkTextCursor 200ms steps(44) infinite normal;
}
@keyframes typewriter{
  from{width: 0;}
  to{width: 3em;}
}
@keyframes blinkTextCursor{
  from{border-right-color: rgba(255,255,255,.75);}
  to{border-right-color: transparent;}
}
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style> 